__turbopack_context__.v({
  "alertTitle": "change-scene-alias-module__o4iHpa__alertTitle",
  "alertURL": "change-scene-alias-module__o4iHpa__alertURL",
  "button": "change-scene-alias-module__o4iHpa__button",
  "buttons": "change-scene-alias-module__o4iHpa__buttons",
  "dropdownContnet": "change-scene-alias-module__o4iHpa__dropdownContnet",
  "error": "change-scene-alias-module__o4iHpa__error",
  "formContainer": "change-scene-alias-module__o4iHpa__formContainer",
  "greenInput": "change-scene-alias-module__o4iHpa__greenInput",
  "info": "change-scene-alias-module__o4iHpa__info",
  "label": "change-scene-alias-module__o4iHpa__label",
  "paragraph": "change-scene-alias-module__o4iHpa__paragraph",
  "previewBaseUrl": "change-scene-alias-module__o4iHpa__previewBaseUrl",
  "previewInput": "change-scene-alias-module__o4iHpa__previewInput",
  "previewLabel": "change-scene-alias-module__o4iHpa__previewLabel",
  "sceneAlias": "change-scene-alias-module__o4iHpa__sceneAlias",
  "success": "change-scene-alias-module__o4iHpa__success",
  "titleModal": "change-scene-alias-module__o4iHpa__titleModal",
});
